import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

// Swiper Imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Swiper Styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const RoomGallerySlider = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  // Get room_id from URL
  const [searchParams] = useSearchParams();
  const roomId = searchParams.get("room_id");

  useEffect(() => {
    if (!roomId) return;

    setLoading(true);

    axios
      .get(
        `${BASE_URL}getpagedata/fetch_room_gallery.php?room_id=${roomId}`
      )
      .then((res) => {
        console.log("RAW API RESPONSE:", res.data);

        const cleaned = res.data.map((item) => ({
          ...item,
          image: item.image.replace(/\\\//g, "/"),
        }));

        setImages(cleaned);
      })
      .catch((error) => console.error("Gallery Error:", error))
      .finally(() => setLoading(false));
  }, [roomId]);

  if (loading) return <p>Loading gallery...</p>;
  if (!images.length) return <p>No images found.</p>;

  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 2500, disableOnInteraction: false }}
      loop={true}
      className="room-swiper"
    >
      {images.map((img, index) => (
        <SwiperSlide key={index}>
          <img
            src={img.image}
            className="w-100 room-slider-img"
            alt={`room-${index}`}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default RoomGallerySlider;
